import { decodeJwtPayload, loadTokens } from "../auth";

const SUPERADMIN_GROUP = "vida-superadmin";

/**
 * Superadmin is derived from the `cognito:groups` claim in the id_token.
 * Caveat: after being added to the group the claim only appears after a token
 * refresh — the launcher offers an "Aggiorna sessione" action to force it.
 */
export function isSuperAdmin(): boolean {
  const t = loadTokens();
  if (!t) return false;
  const payload = decodeJwtPayload(t.id_token);
  const groups = payload?.["cognito:groups"];
  return Array.isArray(groups) && groups.includes(SUPERADMIN_GROUP);
}
